import * as React from "react";

import { useRichTextContext } from "../RichTextContextProvider";

import { Button, View } from "@aws-amplify/ui-react";

import "../../../../styles/quill.css";
import { TooltipView } from "../../../../components/TooltipView";
import useClickOutsideDetection from "../../../../hooks/useClickOutsideDetection";
import ColorPalette from "./ColorPalette";
import { FaHighlighter } from "react-icons/fa";

export interface HighlightProps {}

export default function Highlight(props: HighlightProps) {
  const {} = props;
  const [isOpen, setIsOpen] = React.useState(false);

  const { currentFormats, setCurrentFormats, currentEditor } =
    useRichTextContext();

  const onHighlight = React.useCallback(
    (color: string | undefined) => {
      currentEditor?.format("background", color);
      setCurrentFormats?.(currentEditor?.getFormat());
    },
    [currentEditor]
  );

  const buttonRef = React.useRef<HTMLButtonElement | null>(null);

  const tooltipRef = useClickOutsideDetection(
    (e) => {
      if (buttonRef.current?.contains(e.target as Node)) return;
      if (isOpen) setIsOpen(false);
    },
    [isOpen]
  );

  return (
    <TooltipView
      show={isOpen}
      placement="bottom"
      trigger={"click"}
      tooltipChildren={
        <View ref={tooltipRef}>
          {
            <ColorPalette
              color={currentFormats?.background }
              onSelectColor={onHighlight}
            />
          }
        </View>
      }
      onToggle={(isOpen) => {
        setIsOpen(isOpen);
      }}
    >
      <Button
        ref={buttonRef}
        size="small"
        variation="link"
        height={"100%"}
        direction={"column"}
        fontSize={"xs"}
        fontWeight={"medium"}
        padding={"xxs"}
        gap={"0"}
        lineHeight={1}
      >
        <FaHighlighter />
        <View
          height="2px"
          width="12px"
          backgroundColor={currentFormats?.background || "#dfdf00"}
        />
      </Button>
    </TooltipView>
  );
}
